import React from "react";
import { motion } from "framer-motion";
const pains = [{
  emoji: "😰",
  title: "El paciente llega al control y uno o varios dientes dejaron de seguir el alineador.",
  desc: "Ya sabes lo que viene después. Otro refinamiento. Más tiempo. Más citas. Más desgaste."
}, {
  emoji: "⏰",
  title: "El tratamiento lleva meses y todavía no logras cerrarlo.",
  desc: "Cada nueva cita consume tiempo que podrías dedicar a nuevos pacientes."
}, {
  emoji: "🤔",
  title: "Apruebas el ClinCheck porque visualmente se ve correcto…",
  desc: "…pero algo te dice que ese movimiento probablemente no se expresará como aparece en la pantalla."
}, {
  emoji: "💰",
  title: "Cuando haces números descubres que el caso dejó mucho menos beneficio del esperado.",
  desc: "Los refinamientos silenciosamente reducen la rentabilidad de cada tratamiento."
}, {
  emoji: "😓",
  title: "El paciente empieza a preguntar por qué todavía no termina.",
  desc: "Cada explicación hace más difícil mantener su confianza."
}, {
  emoji: "📉",
  title: "Sabes que muchos refinamientos podrían evitarse…",
  desc: "Pero nunca te enseñaron cómo detectar esos errores antes de comenzar."
}];
export function PainPoints() {
  return <section className="bg-white px-5 py-12" data-id="element-151" data-mp="23rdm2c5c50i2">
      <div className="mx-auto max-w-md" data-id="element-152" data-mp="23soljzrqzm3d">
        <h2 className="text-center font-display text-2xl font-extrabold text-navy-800 sm:text-3xl" data-id="element-153" data-mp="23tresecjm0mg">
          ¿Te suena familiar?
        </h2>
        <p className="mt-3 text-center text-sm text-navy-800/60" data-id="element-154" data-mp="1b3rhp1oa9ru5">
          Si alguna de estas situaciones ocurre en tu consulta… este sistema fue creado para ti.
        </p>

        <div className="mt-6 space-y-3" data-id="element-155" data-mp="1k2wea2gabb3o">
          {pains.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="flex gap-3 rounded-2xl border border-navy-100 bg-navy-50 p-4" data-id="element-156" data-mp="1k5qvll404fsv" data-mpi={i}>
              <div className="text-2xl leading-none" data-id="element-157" data-mp="1y3gk6ib856e6">{p.emoji}</div>
              <div data-id="element-158" data-mp="225tor3e8iy9d">
                <h3 className="font-display text-sm font-bold leading-snug text-navy-800" data-id="element-159" data-mp="225bnfscpttul">{p.title}</h3>
                <p className="mt-1 text-xs leading-relaxed text-navy-800/60" data-id="element-160" data-mp="2756atlxa81aw">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 rounded-2xl bg-navy-800 p-6 text-center text-white" data-id="element-161" data-mp="1acuc4r17zm46">
          <p className="text-sm leading-relaxed text-white/80" data-id="element-162" data-mp="1egijp9puqhpf">
            El Sistema Antirrefinamientos fue creado precisamente para evitar eso.
          </p>
          <div className="my-4 space-y-1 font-display text-lg font-bold" data-id="element-163" data-mp="1o6bu47e9cqs3">
            <p data-id="element-164" data-mp="qqxzknhypeek">No es un libro para estudiar.</p>
            <p data-id="element-165" data-mp="qq51sc0zdz8k">No es un curso de decenas de horas.</p>
            <p className="text-brand-light" data-id="element-166" data-mp="vphpeyzofac7">Es una biblioteca clínica de consulta rápida.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-2 text-xs font-semibold" data-id="element-167" data-mp="o6rwsj533tzl">
            {["Buscas el problema", "Encuentras el protocolo", "Lo aplicas", "Continúas el tratamiento"].map((s, i) => <span key={s} className="rounded-full bg-white/10 px-3 py-1" data-id="element-168" data-mp="e6r8sjw9spp2" data-mpi={i}>
                  {i + 1}. {s}
                </span>)}
          </div>
        </div>
      </div>
    </section>;
}